function ThemeSwitcher(el) {
    this.el = el;

    document.body.addEventListener('click', e => {
        if (e.target.classList.contains('jsThemeSwitcherThemeTitle')) this.el.classList.toggle('open');
        else this.el.classList.remove('open');
    });
}

(function() {
    [...document.querySelectorAll('.jsThemeSwitcher')].forEach(el => new ThemeSwitcher(el));
})();
